var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58268 8.2085H4.83268M6.41602 11.3752H4.83268M11.166 5.04183H4.83268M14.3327 7.81266V4.8835C14.3327 3.55337 14.3327 2.88831 14.0738 2.38027C13.8461 1.93338 13.4828 1.57005 13.0359 1.34236C12.5279 1.0835 11.8628 1.0835 10.5327 1.0835H5.46602C4.13589 1.0835 3.47083 1.0835 2.96279 1.34236C2.5159 1.57005 2.15257 1.93338 1.92488 2.38027C1.66602 2.88831 1.66602 3.55337 1.66602 4.8835V13.1168C1.66602 14.447 1.66602 15.112 1.92488 15.6201C2.15257 16.0669 2.5159 16.4303 2.96279 16.658C3.47083 16.9168 4.13589 16.9168 5.46602 16.9168H7.60352M15.916 16.9168L14.7285 15.7293M15.5202 13.7502C15.5202 15.2805 14.2796 16.521 12.7493 16.521C11.2191 16.521 9.97852 15.2805 9.97852 13.7502C9.97852 12.2199 11.2191 10.9793 12.7493 10.9793C14.2796 10.9793 15.5202 12.2199 15.5202 13.7502Z",
    stroke: "#0092DD",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineActive);
export default __webpack_public_path__ + "static/media/timeline_active.0ef9d6bd54854b58db67efefcbf79957.svg";
export { ForwardRef as ReactComponent };